import { render, staticRenderFns } from "./ReleaseStatusChip.vue?vue&type=template&id=1e4b7c12"
import script from "./ReleaseStatusChip.vue?vue&type=script&lang=js"
export * from "./ReleaseStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports